import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './axiosConfig';
import App from './App';
import PublicReportView from './components/PublicReportView';
import StockPage from './components/StockPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/reports/:jobId" element={<PublicReportView />} />
        <Route path="/stock/:ticker" element={<StockPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
